import { render, staticRenderFns } from "./RolesPage.vue?vue&type=template&id=83e83756&lang=pug"
import script from "./RolesPage.vue?vue&type=script&lang=js"
export * from "./RolesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83e83756')) {
      api.createRecord('83e83756', component.options)
    } else {
      api.reload('83e83756', component.options)
    }
    module.hot.accept("./RolesPage.vue?vue&type=template&id=83e83756&lang=pug", function () {
      api.rerender('83e83756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/roles/RolesPage.vue"
export default component.exports